import { Button, IconCheck } from '@gmg/gmg-react-components';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface SuccesToastWithDonwloadLinkProps {
    fileName: string;
    fileExtension: string;
    fileContent: string;
    notificationTitle: string;
    onDownloadClickHandler?: () => void;
};
export const notificationWithDownloadableFile = (params: SuccesToastWithDonwloadLinkProps) => {
    return <NotificationWithDownloadLink {...params} />;
};

const NotificationWithDownloadLink: FunctionComponent<SuccesToastWithDonwloadLinkProps> = (props) => {
    const { t } = useTranslation();

    return (
        <Main>
            <IconCheck width={22} height={22} />
            <Content>
                <span className="px12_600_normal">
                    {props.notificationTitle}
                </span>
                <span className="px10_400_normal">
                    {props.fileName}.{props.fileExtension}
                </span>
                <NonDecoratedAnchor
                    href={URL.createObjectURL(new Blob([`${props.fileContent}`], { type: 'text/plain' }))}
                    download={`${props.fileName}.${props.fileExtension}`}
                    aria-label={`download ${props.fileName} link`}
                >
                    <Button
                        className="px10_400_normal"
                        aria-label={`download ${props.fileName} button`}
                        variant='secondary'
                        onClick={() => props.onDownloadClickHandler?.()}
                    >
                        {t('ButtonTitles.action_download_btn', 'Download')}
                    </Button>
                </NonDecoratedAnchor>
            </Content>
        </Main >
    );
};

const Main = styled.div`
    display: flex;
    margin: auto 0;
    gap: 16px;
    padding: 0px 24px 16px 8px;
`;

const Content = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
`;

const NonDecoratedAnchor = styled.a`
    text-decoration: none;
`;